<template>
  <click-outside :do="close">
    <div>
      <span
        @click="open"
        class="icon-menu-icon text-2lg cursor-pointer hover:text-primary transition__normal"
        :class="whiteLabel.darkHeader ? 'text-white' : ''"
      ></span>
      <transition name="fade">
        <div v-if="isVisible" class="backdrop" @click="close"></div>
      </transition>
      <transition name="to-left">
        <div v-if="isVisible" class="bg-white fixed top-0 right-0 w-2/3 h-full z-40">
          <div class="flex flex-col justify-between h-full">
            <div class="text-center">
              <!-- close icon -->
              <div class="flex justify-end mt-4">
                <span class="icon-close_icon-1 text-lg text-black font-light p-4" @click="close"></span>
              </div>
              <!-- user -->
              <div>
                <div class="flex justify-center mt-2">
                  <span class="icon-user_icon text-primary text-5xl"></span>
                </div>
                <div
                  class="flex items-center justify-center mt-2 pb-8 mx-8 border-b-1 border-grey-light cursor-pointer"
                  @click.stop="openAccounts"
                >
                  <p>{{ currentInvestor?.full_name || 'Loading...' }}</p>
                  <span class="icon-arrow_drop_down text-grey-dark text-3lg"></span>
                </div>
              </div>
              <!-- links -->
              <div @click="close">
                <router-link
                  :to="{ ...baseRouteConfig, name: 'profile' }"
                  class="block mt-4 py-4 text-sm text-grey-dark"
                  >{{ $t('View Profile') }}</router-link
                >
                <router-link
                  :to="{ ...baseRouteConfig, name: 'dashboard' }"
                  class="block py-4 text-sm text-grey-dark"
                  >{{ $t('Contact Support') }}</router-link
                >
              </div>
              <!-- Languages -->
              <div class="flex justify-center mt-4">
                <Languages />
              </div>
            </div>
            <!-- logout -->
            <div class="flex justify-center mb-20" @click.stop="close">
              <button-module
                grey
                class="bg-grey-dark text-white py-3 px-12"
                @click="$refs.mobileMenuTooltip.toggle()"
                >{{ $t('Logout') }}</button-module
              >
            </div>
          </div>
        </div>
      </transition>
      <accounts :isVisible="showAccounts" @close="showAccounts = false" />
      <!-- logout tooltip -->
      <tooltip ref="mobileMenuTooltip" toolTipClass="w-full">
        <div class="text-center">
          <div class="mt-8"><span class="icon-user_icon text-black text-5xl"></span></div>
          <div class="mt-2 mb-2 mx-8">
            <p class="text-xl">
              {{ currentInvestor?.suffix || '' }} {{ currentInvestor?.first_name || '' }}
              {{ currentInvestor?.last_name || '' }}
            </p>
          </div>
          <p class="text-sm text-grey-dark mb-12">{{ $t('Are you sure you would like to sign out?') }}</p>
          <div class="flex justify-center mb-6">
            <button-module danger class="py-3 px-12" @click="confirmLogout">{{ $t('Logout') }}</button-module>
          </div>
        </div>
      </tooltip>
    </div>
  </click-outside>
</template>

<script>
import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/ButtonModule'
import Tooltip from '@/components/shared/Tooltip'
import Languages from '@/components/header-components/Languages'
import Accounts from '@/components/header-components/Accounts'
import ClickOutside from '@/components/shared/ClickOutside'
import { useInvestorStore } from '@/stores/investor'
import { useCompanyStore } from '@/stores/company'

export default {
  components: {
    ButtonModule,
    Tooltip,
    Languages,
    Accounts,
    ClickOutside
  },

  setup () {
    const investorStore = useInvestorStore()
    const companyStore = useCompanyStore()

    return {
      investorStore,
      companyStore
    }
  },

  data () {
    return {
      showAccounts: false,
      isVisible: false
    }
  },

  computed: {
    currentInvestor () {
      return this.investorStore.currentInvestor
    },
    whiteLabel () {
      return this.companyStore.whiteLabel
    },
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    }
  },

  methods: {
    open () {
      this.isVisible = true
    },

    confirmLogout () {
      this.$router.push({ ...this.baseRouteConfig, name: 'login' })
    },

    openAccounts () {
      this.showAccounts = true
      this.close()
    },

    close () {
      this.isVisible = false
    }
  },

  watch: {
    isVisible (newVal) {
      preventBodyScroll(newVal)
    }
  },

  beforeUnmount () {
    document.getElementsByTagName('html')[0].classList.remove('prevent-body-scroll')
  }
}
</script>
